import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutUs.css';

const AboutUs = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/home');
  };

  return (
    <div className="about-us">
      <button className="about-us-close-button" onClick={handleRedirect}>×</button>
      <h1>About UlsaApp</h1>
      <p>
                UlsaApp is an innovative learning platform by AtoZ Automation Solutions Pvt. Ltd. Our name reflects our core mission: to help individuals build and refine their skills through accessible, technology-driven learning. By integrating smart tools with curated educational resources, we aim to make skill development more effective, engaging, and user-friendly.
      </p>
      <h2>Our Mission</h2>
      <p>
                At UlsaApp, we&apos;re committed to making learning more accessible by offering an intuitive platform where users can explore topics, practice skills, and gain real-world knowledge. Whether you&apos;re a student, professional, or lifelong learner, UlsaApp is here to support your growth.
      </p>
      <h2>Who We Serve</h2>
      <ul>
        <li>Students looking to enhance their learning with practical resources</li>
        <li>Professionals aiming to upskill or reskill in a competitive job market</li>
        <li>Lifelong Learners pursuing knowledge in a variety of subjects at their own pace</li>
      </ul>
      <h2>Key Features</h2>
      <ul>
        <li>Skill-Based Learning Modules: Learn through structured, goal-oriented content</li>
        <li>Interactive Tools: Practice skills through quizzes, challenges, and simulations</li>
        <li>Document Analysis: Upload notes or learning materials for smart insights</li>
        <li>Personalized Learning Paths: Get recommendations tailored to your interests and progress</li>
      </ul>
      <h2>Our Approach</h2>
      <p>
                UlsaApp is designed to support learners at every stage of their journey. Our platform complements traditional education by organizing information in a way that encourages exploration, practical application, and continuous growth.
      </p>
      <h2>About AtoZ Automation Solutions Pvt. Ltd</h2>
      <p>
                UlsaApp is a project by AtoZ Automation Solutions Pvt. Ltd, a company dedicated to developing innovative technological solutions that address real-world challenges across industries.
      </p>
      <h2>Contact Us</h2>
      <p>
                We value your feedback and are here to assist you with any questions or suggestions.
      </p>
      <p className='contact-us'>📧 info.UlsaApp@atozas.com</p>
    </div>
  );
};

export default AboutUs;
